import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { usedIdAtom } from "../atoms/useIdAtom";

const UsedId = () => {
  const [usedIds, setUsedIds] = useRecoilState(usedIdAtom);
  const fetchData = async () => {
    const res = await axios.get(
      "https://chamstudyland.com/api/fun_learning/get_usedId.php"
    );
    const idList = res.data;
    setUsedIds(idList);
  };

  const deleteAll = async () => {
    await axios.get(
      "https://chamstudyland.com/api/fun_learning/delete_usedId.php"
    );
    fetchData();
  };

  const deleteId = async (id: string) => {
    await axios.get(
      `https://chamstudyland.com/api/fun_learning/delete_usedId.php?id=${id}`
    );
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="p-5">
      <div className="flex flex-row items-center gap-5 text-white text-2xl font-bold">
        <div>사용된 ID</div>
        <button
          onClick={deleteAll}
          className="text-base font-bold inline-block w-auto text-center min-w-[100px] px-3 py-2 text-white rounded-md shadow-ㅡㅇ sm:w-auto bg-gradient-to-r from-orange-600 to-orange-500 hover:bg-gradient-to-b dark:shadow-orange-900 shadow-orange-200 hover:shadow-2xl hover:shadow-orange-400 hover:-tranneutral-y-px "
        >
          Reset
        </button>
      </div>
      <div className="mt-4 text-xl text-white flex flex-col gap-2">
        {usedIds.map((id) => (
          <div className="flex flex-row items-center gap-5" key={id}>
            <div>- {id}</div>
            <FontAwesomeIcon
              onClick={() => deleteId(id)}
              className="cursor-pointer"
              color="red"
              icon={faTrash}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsedId;
